import { render, staticRenderFns } from "./GetCustomerOrders.vue?vue&type=template&id=a61e1522&scoped=true&"
import script from "./GetCustomerOrders.vue?vue&type=script&lang=js&"
export * from "./GetCustomerOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a61e1522",
  null
  
)

export default component.exports